export const SCHEDULE_ACTIVITY_TYPES = [
  'dates_filtered',
  'booking_attempted',
  'booking_succeeded',
  'booking_failed',
  'booking_refused',
  'account_blocked',
  'slot_match_failed',
  'insufficient_capacity',
  'race_lost',
  'not_better',
  'schedule_activated',
  'schedule_reactivated',
  'schedule_paused',
  'schedule_delisted',
  'schedule_relisted',
  'rebooking_frozen',
  'blocked',
  'block_released',
  'appointment_cancelled',
  'appointment_cancel_failed',
  'appointment_cancel_unavailable',
  'appointment_expired_cleared',
] as const;

type ScheduleActivityType = (typeof SCHEDULE_ACTIVITY_TYPES)[number];

export const CUSTOMER_ACTIVITY_TYPES = [
  'booking_attempted',
  'booking_succeeded',
  'booking_refused',
  'rebooking_frozen',
  'appointment_cancelled',
  'schedule_activated',
  'schedule_reactivated',
  'schedule_paused',
  'schedule_delisted',
  'schedule_relisted',
] as const satisfies readonly ScheduleActivityType[];

export const CUSTOMER_ACTIVITY_DETAIL_KEYS = [
  'facility',
  'consular_date',
  'consular_time',
  'asc_date',
  'asc_time',
  'asc_facility',
  'booking_id',
  'current_consular_at',
  'current_asc_at',
  'consecutive_absences',
] as const;

export interface ScheduleActivityDetailRow {
  key: string;
  value: string;
}

export function formatScheduleActivityValue(value: unknown): string {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'string') return value;
  if (typeof value === 'number' || typeof value === 'boolean') return String(value);
  return JSON.stringify(value);
}

export function toScheduleActivityRows(
  details: Record<string, unknown> | null | undefined
): ScheduleActivityDetailRow[] {
  if (!details) return [];
  return Object.entries(details).map(([key, value]) => ({
    key,
    value: formatScheduleActivityValue(value),
  }));
}
